var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKingBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=King Bed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 11.975C2 11.425 2.19583 10.9583 2.5875 10.575C2.97917 10.1917 3.45 10 4 10V7C4 6.45 4.19583 5.97917 4.5875 5.5875C4.97917 5.19583 5.45 5 6 5H18C18.55 5 19.0208 5.19583 19.4125 5.5875C19.8042 5.97917 20 6.45 20 7V10C20.55 10 21.0208 10.1958 21.4125 10.5875C21.8042 10.9792 22 11.45 22 12V15.65C22 16.0333 21.8708 16.3542 21.6125 16.6125C21.3542 16.8708 21.0333 17 20.65 17L20.1 18.675C20.0667 18.775 20.0083 18.8542 19.925 18.9125C19.8417 18.9708 19.75 19 19.65 19H19.35C19.25 19 19.1583 18.9708 19.075 18.9125C18.9917 18.8542 18.9333 18.775 18.9 18.675L18.35 17H5.65L5.1 18.675C5.06667 18.775 5.00833 18.8542 4.925 18.9125C4.84167 18.9708 4.75 19 4.65 19H4.35C4.25 19 4.15833 18.9708 4.075 18.9125C3.99167 18.8542 3.93333 18.775 3.9 18.675L3.35 17C2.96667 17 2.64583 16.8708 2.3875 16.6125C2.12917 16.3542 2 16.0333 2 15.65V11.975ZM13 10H18V7H13V10ZM6 10H11V7H6V10Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingBed);
export default __webpack_public_path__ + "static/media/king-bed.1162d8cee87e6f5a61f4fbfc0b4c4651.svg";
export { ForwardRef as ReactComponent };